import styles from "./Image2.module.css";
function Image ({ src, alt }) {
    return (
        <div>
            <img src={src} alt={alt} className={styles.img}/>
        </div>
    )
}

export default Image